import _ from 'lodash'
const SEMICONDUCTORS_SEARCH_CONFIG = {
    form: _.select('#form--semiconductors-search'),
    diodesJSON: _.select('#form--semiconductors-search input[name="diodesJSON"]'),
    thyristorsJSON: _.select('#form--semiconductors-search input[name="thyristorsJSON"]'),
    diodesUrl: _.select('#form--semiconductors-search input[name="diodesUrl"]'),
    thyristorsUrl: _.select('#form--semiconductors-search input[name="thyristorsUrl"]')
}

export default SEMICONDUCTORS_SEARCH_CONFIG